module.exports = __webpack_public_path__ + "img/saum_grau_candy.7861d7a7.jpg";